import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { rewardClaimDetailMock } from "./mock";
import { RewardDetailHeader } from "./components/RewardDetailHeader";
import { RewardDetailRewards } from "./components/RewardDetailRewards";
import { RewardOwnerChat } from "./components/RewardOwnerChat";
import { RewardRequestPanel } from "./components/RewardRequestPanel";

export function MyRewardDetail() {
  const [searchParams] = useSearchParams();
  const claimId = searchParams.get("claim");

  const detail = useMemo(() => {
    if (!claimId) return rewardClaimDetailMock;

    const selectedReward = rewardClaimDetailMock.rewards.find(
      (reward) => String(reward.claimId) === claimId,
    );

    if (!selectedReward) return rewardClaimDetailMock;

    return {
      ...rewardClaimDetailMock,
      rewards: [
        selectedReward,
        ...rewardClaimDetailMock.rewards.filter(
          (reward) => reward.claimId !== selectedReward.claimId,
        ),
      ],
    };
  }, [claimId]);

  return (
    <section className="bg-light pt-5 pb-4 px-3 overflow-hidden">
      <div className="container px-3 px-md-4 px-lg-0">
        <div className="mb-4">
          <h1 className="h3 fw-bold mb-1">Detalhes da Premiação</h1>
          <p className="text-muted mb-0">
            Acompanhe a solicitação, os arquivos e a conversa sobre seus prêmios.
          </p>
        </div>

        <RewardDetailHeader detail={detail} />

        <div className="row g-4">
          <div className="col-12 col-xl-7">
            <RewardDetailRewards
              rewards={detail.rewards}
              files={detail.files}
              requirements={detail.requirements}
            />
          </div>
          <div className="col-12 col-xl-5">
            <RewardRequestPanel detail={detail} />
          </div>
          <div className="col-12">
            <RewardOwnerChat messages={detail.messages} />
          </div>
        </div>
      </div>
    </section>
  );
}
